import { render, staticRenderFns } from "./TagIndex.vue?vue&type=template&id=ce462266&scoped=true&"
import script from "./TagIndex.vue?vue&type=script&lang=js&"
export * from "./TagIndex.vue?vue&type=script&lang=js&"
import style0 from "./TagIndex.vue?vue&type=style&index=0&id=ce462266&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce462266",
  null
  
)

component.options.__file = "TagIndex.vue"
export default component.exports